import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { UserEffects } from './user.effects';
import { usersReducer } from './user.reducer';

export const provideUserStore = () => [provideState('users', usersReducer), provideEffects([UserEffects])];
